import animateCounter from "../helpers/counter";

class CounterBanner {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        this.root = el;
        this.counterEl = this.root.querySelectorAll('[data-counter]');
        return this.counterEl.length > 0;
    }

    init() {
        this.createObserver();
    }

    runCounters() {
        this.counterEl.forEach(el => {
            if (el.dataset.started) return; // prevent rerun

            const endValue = parseInt(el.dataset.counter, 10) || 0;
            const duration = parseInt(el.dataset.duration, 10) || 2000;

            el.dataset.started = 'true';
            animateCounter(el, endValue, duration);
        });
    }

    createObserver() {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.runCounters();
                    obs.unobserve(this.root); // run once
                }
            });
        }, {
            threshold: 0.3 // trigger when 30% visible
        });

        observer.observe(this.root);
    }
}

const initCounterBanner = () => {
    const sections = document.querySelectorAll('[data-counter-banner]');

    if (sections.length) {
        sections.forEach(item => new CounterBanner(item));
    }
};

initCounterBanner();